import { abyssColors } from '@/theme/colors';
import { styled as muiStyled, Stack, IconButton } from '@mui/material';
import { File } from '@/__generated__/graphql';

export const MainImageContainer = muiStyled(Stack)(() => ({
  width: '100%',
  flex: '1 1 auto',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',
  borderRadius: '0.2rem',
  padding: '0.4rem',
  border: `0.1rem solid ${abyssColors.primary[100]}`,
  transition: 'all 0.2s ease-in-out',
}));
export const getThumbnailStyles = (selectedIsometricFileId: string, file: File) => {
  return {
    height: '8rem',
    width: 'fit-content',
    borderRadius: '0.4rem',
    overflow: 'hidden',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    boxSizing: 'border-box',
    border:
      selectedIsometricFileId === file?.id
        ? `0.2rem solid ${abyssColors.secondary[600]}`
        : `0.2rem solid ${abyssColors.primary[200]}`,
    '&:hover': {
      filter: 'brightness(0.9)',
    },
  };
};

export const SliderContainer = muiStyled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  position: 'relative',
  marginTop: '1rem',
  '& .center-slide-content': {
    width: '100%',
    '& .slick-slide': {
      display: 'flex !important',
      justifyContent: 'center !important',
      alignItems: 'center !important',
      textAlign: 'center !important',
      float: 'none !important',
      opacity: 0.7,
      transition: 'opacity 0.3s ease',
      '&.slick-active': {
        opacity: 1,
      },
      '&.slick-current': {
        opacity: 1,
      },
    },
    '& .slick-track': {
      display: 'flex !important',
      alignItems: 'center !important',
      justifyContent: 'center !important',
      margin: '0 auto !important',
    },
    '& .slick-list': {
      overflow: 'hidden !important',
      margin: '0 auto !important',
    },
    '& .slick-slider': {
      textAlign: 'center !important',
      overflow: 'hidden !important',
      width: '100% !important',
    },
  },
}));

export const NavigationButton = muiStyled(IconButton)(() => ({
  position: 'absolute',
  zIndex: 10,
  color: abyssColors.primary[600],
  padding: '0.4rem',
  top: '50%',
  transform: 'translateY(-50%)',
  backgroundColor: 'rgba(255, 255, 255, 0.7)',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
  },
  '&.prev-button': {
    left: '-1.2rem',
  },
  '&.next-button': {
    right: '-1.2rem',
  },
}));
